<template>
  <!-- 只有在 show 为 true 时才显示 -->
  <div v-if="show" class="no-data-container">
    <img :src="imageSrc" :alt="altText" class="no-data-img" />
  </div>
  <div v-if="show" class="no-more">暂无数据</div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    // 控制是否显示无数据状态
    show: {
      type: Boolean,
      default: false
    },
    // 图片路径（可自定义）
    imageSrc: {
      type: String,
      default: require('@/assets/img/no-data.png') // 默认图片，放在 assets 目录下
    },
    // 图片的 alt 文本
    altText: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style scoped>
/* 容器：作为父级占位，通常嵌入在数据区域中 */
.no-data-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  /* 距离容器顶部 30% */
  align-items: flex-start;
  padding-top: 30%;
  box-sizing: border-box;
}

/* 图片样式 */
.no-data-img {
  width: 120px;
  height: auto;
  opacity: 0.8;
}
</style>